import serialport from './serialport';
import BrowserSerialPort from './browserSerialport';
import delegate from './chromeDelegate';
let validConnections = { serialport };
let extensionId = "";

/**
 * chrome book 硬件全局适配类，将蓝牙、wifi、hid全部抽象成串口，对外提供无差别连接
 *
 * @class ChromeHardwareClient
 */
class ChromeHardwareClient {
    constructor() {

    }
    /**
     * 获取chrome serialport对象
     *
     * @returns chrome serialport对象
     * @memberof ChromeHardwareClient
     */
    getChromeSerialPort() {
        return validConnections.serialport;
    }
    /**
     * 根据连接类型获取串口对象
     *
     * @param {string} type 连接类型，取值为[serialport | hid | ble | wifi]
     * @returns 满足chrome serialport接口对象
     * @memberof ChromeHardwareClient
     */
    getPort(type) {
        if (type in validConnections) {
            return this.getChromeSerialPort();
        }
        console.error('Invalid connectType ', type)
    }

    // addDataListener(listener) {
    //   for (let type in validConnections) {
    //     let port = validConnections[type];
    //     port.onReceive.addListener((message) => {
    //       listener({ type, ...message });
    //     });
    //   }
    // }
    // addErrorListener(listener) {
    //   for (let type in validConnections) {
    //     let port = validConnections[type];
    //     port.onReceiveError.addListener((message) => {
    //       listener({ type, ...message });
    //     });
    //   }
    // }
    
    sendMessage(message, callback) {
        delegate.sendMessage(message, callback);
    }

    getChannelConnected(){
        return delegate.isConnected();
    }

}
let inst = new ChromeHardwareClient();

/**
 *
 *将chrome serialport 转换成 node serialport
 * @class SuperSerialPort
 * @extends {BrowserSerialPort.SerialPort}
 */
class SuperSerialPort extends BrowserSerialPort.SerialPort {

    /**
     *Creates an instance of SuperSerialPort.
     * @param {string} path
     * @param {*} options {connectType:<serialport | ble | hid>, baudRate:115200}
     * @param {*} callback
     * @memberof SuperSerialPort
     */
    constructor(path, options, callback) {
        if (!options) {
            options = {
                connectType: 'serialport',
                baudRate: 115200,
            }
        }
        options.serial = inst.getPort(options.connectType);
        super(path, options, false, callback);
    }
    /**
     *
     * 列举所有串口
     * @static
     * @param {*} type
     * @param {*} callback
     * @memberof SuperSerialPort
     */
    static list(type, callback) {
        console.log('begin list', type);
        inst.getPort(type).getDevices(function (ports) {
            let portObjects = new Array(ports.length);
            for (let i = 0; i < ports.length; i++) {
                portObjects[i] = {
                    comName: ports[i].path,
                    manufacturer: ports[i].displayName,
                    serialNumber: '',
                    pnpId: '',
                    locationId: '',
                    vendorId: '0x' + (ports[i].vendorId || 0).toString(16),
                    productId: '0x' + (ports[i].productId || 0).toString(16)
                };
            }
            callback(chrome.runtime.lastError, portObjects);
        });
    }
}

function getInstance(){
    let channel = inst;
    let SerialPort = SuperSerialPort; //将chrome serialport 包装后的node serialport
    return {channel, SerialPort};
}
export {
    getInstance as default,
    
}

